import { render } from "./inventoryStock.vue?vue&type=template&id=6628f519&scoped=true"
import script from "./inventoryStock.vue?vue&type=script&lang=js"
export * from "./inventoryStock.vue?vue&type=script&lang=js"

import "./inventoryStock.vue?vue&type=style&index=0&id=6628f519&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6628f519"]])

export default __exports__